import {
  ConvertibleUnit,
  format,
  FormatOptions,
  Unit,
} from '@dynatrace-sdk/units';

import { isFormatterOptions, Formatter } from '../../core/types/formatter.js';

/**
 * Returns a formatter function based on the given formatter options.
 *
 * @param formatter - a Formatter or FormatOptions object
 * @returns a formatter function
 */
export function getFormatter(
  formatter: Formatter | FormatOptions<Unit, ConvertibleUnit>,
): Formatter {
  return (value, unit) =>
    isFormatterOptions(formatter)
      ? format(value, formatter)
      : formatter(value, unit);
}
